module.exports = __webpack_public_path__ + "static/media/logo-mobile-black.04725cb4.svg";